<template>
  <collapse title="Competitions" :defaultCollapse="false">
    <season @change="$emit('changeSeason', $event)" />
    <area-zone @change="$emit('changeArea', $event)" />
    <competitions @change="$emit('changeCompetition', $event)" />
  </collapse>
</template>

<script>
import Collapse from '@/components/tools/collapse/Collapse'

import AreaZone from '@/components/sport/games/filters/competition/Area'
import Competitions from '@/components/sport/games/filters/competition/Competitions'
import Season from '@/components/sport/games/filters/competition/Season'
export default {
  name: 'SportGamesFiltersCompetition',
  components: { AreaZone, Collapse, Competitions, Season }
}
</script>
